export const FETCH_MATCH_PRODUCTS_REQUEST = "FETCH_MATCH_PRODUCTS_REQUEST";
export const FETCH_MATCH_PRODUCTS_SUCCESS = "FETCH_MATCH_PRODUCTS_SUCCESS";
export const FETCH_MATCH_PRODUCTS_FAIL = "FETCH_MATCH_PRODUCTS_FAIL";